<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="#d98880">
                            <v-toolbar-title class="my-0 py-0">CIERRE - PLANILLA DE LANZAMIENTO</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <h6 color="black"><b>Datos del Cliente </b></h6>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="4">
                                    <h6> Razón Social: {{ codgral }} - {{ empresa }} </h6>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <h6> CUIT: {{ cuit }} </h6>
                                </v-col>
                                <v-col cols="6" sm="6" md="4">
                                    <h6> Domicilio: {{ domicilio }} </h6>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <h6> Localidad: {{ localidad }} </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <h6> Contacto Comercial: {{ contactocom }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6>Teléfono Comercial: {{ telcom }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6>Mail Comercial: {{ mailcom }}</h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <h6> Contacto Técnico: {{ contactotec }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6>Teléfono Técnico: {{ teltec }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6>Mail Técnico: {{ mailtec }}</h6>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#f2d7d5">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="3">
                                    <h6 color="black"><b>OC N°: {{ codoc }}</b></h6>
                                </v-col>

                                <v-col cols="12" sm="6" md="5">
                                    <h6 color="black"><b>Provisión: {{ provision }}
                                        </b>
                                    </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6 color="black"><b>Responsable Comercial: {{ responsable }}
                                        </b>
                                    </h6>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <v-data-table dense :headers="headersOC" :items="listadooc" locale="es-ar" height="180"
                                fixed-header :items-per-page="200" hide-default-footer class="pa-0 ma-0"
                                :item-class="setRowStyle"></v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <v-row dense>

                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field dense v-model="periodo" label="Año para considerar en estadística"
                                        color="black" outlined></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-select color="black" dense v-model="estado" :items="estados" label="Estado"
                                        item-text="nombre" item-value="valor" outlined>
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field dense v-model="fecha" label="Fecha" color="black"
                                        outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-textarea dense v-model="observ" rows="3" label="Observaciones" auto-grow outlined
                                        color="black"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card>
                        <v-card-text>
                            <v-data-table dense :headers="headersP" :items="listadoproducto" locale="es-ar" height="250"
                                fixed-header :items-per-page="200" hide-default-footer class="pa-0 ma-0"
                                :item-class="setRowStyle">
                                <template v-slot:top>
                                    <!-- <v-toolbar flat> -->
                                    <v-dialog v-model="dialogDelete" max-width="500px">
                                        <v-card>
                                            <v-card-title class="headline">Está seguro que desea
                                                borrar?</v-card-title>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                    <!-- </v-toolbar> -->
                                </template>
                                <template v-slot:item.producto="{ item }">
                                    <v-select dense v-model="item.producto" :items="listadotipo" item-text="producto"
                                        item-value="producto" class="font-class-name"
                                        @change="updateModelOptions(item)"></v-select>
                                </template>
                                <template v-slot:item.modelo="{ item }">
                                    <v-select dense v-model="item.modelo" :items="item.filteredModelos"
                                        item-text="modelo" item-value="modelo" class="font-class-name"
                                        @change="updateFuncionOptions(item)"></v-select>
                                </template>
                                <template v-slot:item.funcion="{ item }">
                                    <v-select dense v-model="item.funcion" :items="item.filteredFuncion"
                                        item-text="funcion" item-value="funcion" class="font-class-name"></v-select>
                                </template>
                                <template v-slot:item.tension="{ item }">
                                    <v-text-field dense v-model="item.tension" class="font-class-name"></v-text-field>
                                </template>
                                <template v-slot:item.potencia="{ item }">
                                    <v-text-field dense v-model="item.potencia" class="font-class-name"></v-text-field>
                                </template>
                                <template v-slot:item.ibb="{ item }">
                                    <v-text-field dense v-model="item.ibb" class="font-class-name"></v-text-field>
                                </template>
                                <template v-slot:item.icc="{ item }">
                                    <v-text-field dense v-model="item.icc" class="font-class-name"></v-text-field>
                                </template>
                                <template v-slot:item.inominal="{ item }">
                                    <v-text-field dense v-model="item.inominal" class="font-class-name"></v-text-field>
                                </template>
                                <template v-slot:item.observ="{ item }">
                                    <v-text-field dense v-model="item.observ" class="font-class-name"></v-text-field>
                                </template>
                                <template v-slot:item.cantidad="{ item }">
                                    <v-text-field dense v-model="item.cantidad" class="font-class-name"></v-text-field>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small color="red" @click="deleteItem(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                            </v-data-table>
                            <v-btn dense class="mx-2" dark small color="yellow" @click="addRowP()">Agregar
                                fila</v-btn>
                        </v-card-text>
                    </v-card>
                    <v-card v-if="mostrarobra == true">
                        <v-card-text>
                            <h6>Datos para Antecendentes de Obras:</h6>
                            <v-row dense>
                                <v-col cols="6" sm="4" md="4">
                                    <v-text-field label="Nombre de la obra" dense v-model="obra"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-text-field label="Ubicación" dense v-model="ubicacion"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-text-field label="Comitente" dense v-model="comitente"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field label="Breve descripción de la obra:" dense v-model="descripcion"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="3" md="3">
                                    <v-text-field label="Monto de Obra Original" dense v-model="montoobra"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <v-text-field label="Plazo de Obra Original en días" dense v-model="plazoobra"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <v-text-field label="Adenda de Obra" dense v-model="adendamonto"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <v-text-field label="Adenda de Plazo" dense v-model="adendaplazo"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="4" md="4">
                                    <v-text-field label="Fecha firma de Contrato" dense v-model="fechacontrato"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-text-field label="Fecha inicio de Obra" dense v-model="fechainicio"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-text-field label="Fecha final de Obra" dense v-model="fechafinal"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="4" md="2">
                                    <v-text-field label="Participación %" dense v-model="participacion"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="4" md="3">
                                    <v-select dense color="red darken-3" v-model="especialidad1"
                                        :items="itemespecialidad" label="Especialidad" item-text="nombre"
                                        item-value="valor"></v-select>
                                </v-col>
                                <v-col cols="6" sm="4" md="2">
                                    <v-text-field label="Especialidad %" dense v-model="porcespec1"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="4" md="3">
                                    <v-select dense color="red darken-3" v-model="especialidad2"
                                        :items="itemespecialidad" label="Especialidad" item-text="nombre"
                                        item-value="valor"></v-select>
                                </v-col>
                                <v-col cols="6" sm="4" md="2">
                                    <v-text-field label="Especialidad %" dense v-model="porcespec2"
                                        class="font-class-name"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#d98880" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>
<style scoped>
.font-class-name {
    font-size: 12px;
}
</style>

<script>
import moment from "moment";
import axios from "../../axios-auth";
import readXlsFile from "read-excel-file";
import { escape } from "lodash";
import { provide } from "vue";
export default {
    data: (vm) => ({
        deshabilitar: false,
        usuario: "",
        valid: false,
        lazy: false,
        fact: "",
        empresa: "",
        cuit: "",
        domicilio: "",
        localidad: "",
        contactocom: "",
        contactotec: "",
        telcom: "",
        teltec: "",
        mailcom: "",
        mailtec: "",
        provision: "",
        responsable: "",
        fecha: moment().format("DD/MM/YYYY"),
        periodo: "",
        observ: "",
        listadooc: [],
        headersOC: [{
            text: "Item",
            align: "start",
            sortable: false,
            value: "item",
            width: "10%"
        },
        { text: "Detalle", value: "descr", sortable: false, width: "50%" },
        { text: "Cantidad", value: "cantidad", sortable: false, width: "10%" },
        { text: "Precio Unitario Dólares", value: "precio", sortable: false, width: "15%" },
        { text: "Precio Unitario Pesos", value: "preciopesos", sortable: false, width: "15%" },
        ],
        headersP: [{
            text: "Tipo de Producto",
            align: "start",
            sortable: false,
            value: "producto"
        },
        { text: "Modelo", value: "modelo", sortable: false },
        { text: "Función", value: "funcion", sortable: false },
        { text: "Tensión", value: "tension", sortable: false },
        { text: "Potencia", value: "potencia", sortable: false },
        { text: "I Bus Barra", value: "ibb", sortable: false },
        { text: "Icc", value: "icc", sortable: false },
        { text: "I Nominal", value: "inominal", sortable: false },
        { text: "Observaciones", value: "observ", sortable: false },
        { text: "Cantidad", value: "cantidad", sortable: false },
        { text: "Borrar", value: "actions", sortable: false },
        ],
        listadooc: [{ item: "", descr: "", cantidad: "", precio: "" },
        { item: "", descr: "", cantidad: "", precio: "" },
        { item: "", descr: "", cantidad: "", precio: "" },],
        listadoentregas: [{ fecha: "", descr: "" },
        { fecha: "", descr: "" },
        { fecha: "", descr: "" },
        { fecha: "", descr: "" },
        ],
        // listadoproducto: [
        //     { producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
        //     { producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
        //     { producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
        //     { producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
        // ],
        listadoproducto: [],
        listadotipo: [],
        listadomodelo: [],
        listadofuncion: [],
        estado: "P",
        estados: [
            { nombre: 'Pendiente', valor: 'P' },
            { nombre: 'Cerrado', valor: 'T' },
        ],
        comercial: [],
        listadop: [],
        dialogDelete: false,
        editedIndex: -1,
        editedItem: {
            producto: "",
            modelo: "",
            funcion: "",

        },
        mostrarobra: false,
        ubicacion: "",
        obra: "",
        descripcion: "",
        comitente: "",
        montoobra: "",
        plazoobra: "",
        adendamonto: "",
        adendaplazo: "",
        fechacontrato: "",
        fechainicio: "",
        fechafinal: "",
        participacion: "",
        especialidad1: "",
        especialidad2: "",
        itemespecialidad: [
            { nombre: "Arquitectura", valor: "Arquitectura" },
            { nombre: "Ingeniería Eléctrica", valor: "Ingeniería Eléctrica" },
            { nombre: "Ingeniería Mecánica", valor: "Ingeniería Mecánica" },
            { nombre: "Saneamiento", valor: "Saneamiento" },
            { nombre: "Red de Gas", valor: "Red de Gas" },
            { nombre: "Pavimentos Rígidos", valor: "Pavimentos Rígidos" },
            { nombre: "Pavimentos Flexibles", valor: "Pavimentos Flexibles" },
            { nombre: "Hidráulica", valor: "Hidráulica" },
            { nombre: "Obras Básicas", valor: "Obras Básicas" },
            { nombre: "Obras de Arte", valor: "Obras de Arte" },
        ],
        porcespec1: "",
        porcespec2: "",
        antecobra: {},
    }),
    props: ["visible", "codgral", "codoc"],
    computed: {

        show: {
            get() {
                if (this.visible == true) {
                    this.responsable = this.$store.state.nombre.toString().trim();
                    this.cargardatos();
                    this.cargartipoproducto();
                    this.cargarmodelo();
                    this.cargarfuncion();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        cargartipoproducto() {
            let self = this;
            axios
                .get("/Lanzamiento/ListadoTipoproducto?")
                .then((response) => {
                    self.listadotipo = response.data;
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        cargarmodelo() {
            let self = this;
            axios
                .get("/Lanzamiento/ListadoModelo?")
                .then((response) => {
                    self.listadomodelo = response.data;
                    //self.listadofuncion = [];
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        cargarfuncion() {
            let self = this;
            axios
                .get("/Lanzamiento/ListadoFuncion?")
                .then((response) => {
                    self.listadofuncion = response.data;
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },
        cargardatos() {
            const codgral = this.codgral;
            const codoc = this.codoc;
            this.loadtable = true;
            let self = this;
            axios
                .get("/Lanzamiento/CargarCierre?", {
                    params: {
                        codgral: codgral,
                        codoc: codoc,
                    },
                })
                .then((response) => {
                    self.empresa = response.data.empresa;
                    self.cuit = response.data.cuit;
                    self.domicilio = response.data.domicilio;
                    self.localidad = response.data.localidad;
                    self.contactocom = response.data.contactocom;
                    self.telcom = response.data.telcom;
                    self.mailcom = response.data.mailcom;
                    self.contactotec = response.data.contactotec;
                    self.teltec = response.data.teltec;
                    self.mailtec = response.data.mailtec;
                    self.provision = response.data.provision;
                    self.responsable = response.data.responsable;
                    self.estado = response.data.estado;
                    self.periodo = response.data.periodo;
                    self.fecha = response.data.fechacierre;
                    self.observ = response.data.observ;
                    self.listadooc = response.data.detalleoc;
                    response.data.productos.forEach((element) => {
                        self.listadoproducto.push({
                            producto: element.producto,
                            modelo: element.modelo,
                            funcion: element.funcion,
                            tension: element.tension,
                            potencia: element.potencia,
                            ibb: element.ibb,
                            icc: element.icc,
                            inominal: element.inominal,
                            observ: element.observ,
                            cantidad: element.cantidad,
                            filteredModelos: response.data.productos
                                .filter(prod => prod.modelo === element.modelo)
                                .map(prod => prod.modelo),
                            filteredFuncion: response.data.productos
                                .filter(prod => prod.funcion === element.funcion)
                                .map(prod => prod.funcion),
                        });
                        if (element.producto == "Obras") {
                            self.mostrarobra = true;
                            self.obra = response.data.antecedentes.obra;
                            self.ubicacion = response.data.antecedentes.ubicacion;
                            self.comitente = response.data.antecedentes.comitente;
                            self.descripcion = response.data.antecedentes.descripcion;
                            self.montoobra = response.data.antecedentes.montoobra;
                            self.plazoobra = response.data.antecedentes.plazoobra;
                            self.adendamonto = response.data.antecedentes.adendamonto;
                            self.adendaplazo = response.data.antecedentes.adendaplazo;
                            self.fechacontrato = response.data.antecedentes.fechacontrato;
                            self.fechainicio = response.data.antecedentes.fechainicio;
                            self.fechafinal = response.data.antecedentes.fechafinal;
                            self.participacion = response.data.antecedentes.participacion;
                            self.especialidad1 = response.data.antecedentes.especialidad1;
                            self.especialidad2 = response.data.antecedentes.especialidad2;

                        }
                    })

                    self.loadtable = false;

                    if (self.listadoproducto.length == 0) {
                        self.listadoproducto = [{ producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
                        { producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
                        { producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
                        { producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
                        ]
                    }

                    console.log("LISTADO", self.listadoproducto)
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        updateModelOptions(item) {
            // Filtra los modelos basados en el tipo seleccionado
            item.filteredModelos = this.listadomodelo.filter(modelo => modelo.producto === item.producto);
            console.log("modelo", item.producto)
            if (String(item.producto).trim() === "Obras") {
                this.mostrarobra = true;
            }
            // Opcional: Puedes establecer un valor predeterminado si es necesario
            // item.modelo = item.filteredModelos.length > 0 ? item.filteredModelos[0].valor : null;
        },

        updateFuncionOptions(item) {
            item.filteredFuncion = this.listadofuncion.filter(funcion => funcion.producto === item.producto && funcion.modelo === item.modelo);
        },

        setRowStyle(item) {
            return 'style-1'
        },

        addRowP() {
            this.listadoproducto.push({ producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },)
        },


        deleteItem(item) {
            this.editedIndex = this.listadoproducto.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        deleteItemConfirm() {
            this.listadoproducto.splice(this.editedIndex, 1);
            this.closeDelete();
        },

        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar OC",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var i = 0

                    i = 0;
                    this.listadoproducto.forEach((element) => {
                        if (element.producto != "" && element.producto != null) {

                            this.listadop.push({
                                codgral: this.codgral,
                                codoc: this.codoc,
                                producto: element.producto,
                                modelo: element.modelo,
                                funcion: element.funcion,
                                tension: element.tension,
                                potencia: element.potencia,
                                ibb: element.ibb,
                                icc: element.icc,
                                inominal: element.inominal,
                                observ: element.observ,
                                cantidad: element.cantidad
                            });
                        }
                    });
                    this.antecobra.codgral = this.codgral;
                    this.antecobra.codoc = this.codoc;
                    this.antecobra.obra = this.obra;
                    this.antecobra.comitente = this.comitente;
                    this.antecobra.ubicacion = this.ubicacion;
                    this.antecobra.descripcion = this.descripcion;
                    this.antecobra.monto = this.montoobra;
                    this.antecobra.plazo = this.plazoobra;
                    this.antecobra.adendamonto = this.adendamonto;
                    this.antecobra.adendaplazo = this.adendaplazo;
                    this.antecobra.fechacontrato = this.fechacontrato;
                    this.antecobra.fechainicio = this.fechainicio;
                    this.antecobra.fechafinal = this.fechafinal;
                    this.antecobra.participacion = this.participacion;
                    this.antecobra.especialidad1 = this.especialidad1;
                    this.antecobra.especialidad2 = this.especialidad2;
                    this.antecobra.porcespec1 = this.porcespec1;
                    this.antecobra.porcespec2 = this.porcespec2;

                    var datos = {
                        codoc: this.codoc,
                        codgral: this.codgral,
                        periodo: this.periodo,
                        observ: this.observ,
                        fecha: this.fecha,
                        estado: this.estado,
                        producto: this.listadop,
                        antecedentes: this.antecobra,
                    };

                    let self = this;
                    axios
                        .post("/Lanzamiento/GuardarCierre", datos)
                        .then((response) => {
                            self.showAlert({
                                icon: "success",
                                title: "Cierre guardado con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            // setTimeout(() => {
                            //     self.$router.push({ name: "LanzamientoMain" });
                            // }, 5000);
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 8000,
            });
        },

        vaciarListado() {
            this.empresa = "";
            this.cuit = "";
            this.domicilio = "";
            this.localidad = "";
            this.contactocom = "";
            this.telcom = "";
            this.mailcom = "";
            this.contactotec = "";
            this.teltec = "";
            this.mailtec = "";
            this.provision = "";
            this.responsable = "";
            this.estado = "";
            this.listadooc = [];
            this.listadoproducto = [];
            this.listadop = [];
            this.listadofuncion = [];
            this.listadomodelo = [];
            this.ubicacion = "";
            this.obra = "";
            this.descripcion = "";
            this.comitente = "";
            this.montoobra = "";
            this.plazoobra = "";
            this.adendamonto = "";
            this.adendaplazo = "";
            this.fechacontrato = "";
            this.fechainicio = "";
            this.fechafinal = "";
            this.participacion = "";
            this.especialidad1 = "";
            this.especialidad2 = "";
            this.antecobra = {};
            this.deshabilitar = false;
            this.mostrarobra = false;
            this.periodo = "";
            this.observ = "";
            this.fecha = "";

        },
    },
};
</script>